// Generate historical data points with realistic variations
function generateHistoricalData(basePrice: number, baseHashrate: number, blockReward: number, days: number) {
  const data = [];
  let currentPrice = basePrice;
  let currentHashrate = baseHashrate;

  for (let i = days; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    
    // Add random price variation (±5%)
    const priceChange = (Math.random() - 0.5) * 0.1;
    currentPrice = currentPrice * (1 + priceChange);
    
    // Add random hashrate variation (±10%)
    const hashrateChange = (Math.random() - 0.5) * 0.2;
    currentHashrate = baseHashrate * (1 + hashrateChange);

    data.push({
      date: date.toISOString(),
      price: currentPrice,
      networkHashrate: currentHashrate,
      blockReward
    });
  }

  return data;
}

export const fallbackHistoricalData = {
  BTC: generateHistoricalData(72150, 650000000, 3.125, 90), // 650 EH/s = 650M TH/s
  LTC: generateHistoricalData(84.41, 950000, 12.5, 90),     // 950 TH/s
  ETH: generateHistoricalData(3975, 1200000, 0.15, 90),     // 1.2 PH/s = 1.2M TH/s
  KDA: generateHistoricalData(1.45, 750000, 0.7, 90)        // 750 TH/s
};

export const fallbackNetworkStats = {
  BTC: {
    hashrate_24h: 650000000, // TH/s
    difficulty: 71.6e12,
    blockReward: 3.125,
    blockTime: 600
  },
  LTC: {
    hashrate_24h: 950000,    // TH/s
    difficulty: 23.4e6,
    blockReward: 12.5,
    blockTime: 150
  },
  ETH: {
    hashrate_24h: 1200000,   // TH/s
    difficulty: 12.8e15,
    blockReward: 0.15,
    blockTime: 12
  },
  KDA: {
    hashrate_24h: 750000,    // TH/s
    difficulty: 8.9e9,
    blockReward: 0.7,
    blockTime: 30
  }
};